<template>
  <v-container
    grid-list-xl
    fluid
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
      >
        <v-widget
          :title="$t('My Account')"
          class="mb-4"
        >
          <div slot="widget-content">
            <v-form>
              <v-text-field
                v-model="user.email"
                :error-count="user.displayErrors('email').length"
                :error-messages="user.displayErrors('email')"
                :label="$t('Email')"
                outline
              />
              <v-text-field
                v-model="user.name"
                :error-count="user.displayErrors('name').length"
                :error-messages="user.displayErrors('name')"
                :label="$t('Name')"
                outline
              />

              <v-text-field
                v-model="user.password"
                :error-count="user.displayErrors('password').length"
                :error-messages="user.displayErrors('password')"
                :label="$t('New Password')"
                outline
                type="password"
              />
              <v-text-field
                v-model="user.password_confirmation"
                :error-count="user.displayErrors('password_confirmation').length"
                :error-messages="user.displayErrors('password_confirmation')"
                :label="$t('Password Confirmation')"
                outline
                type="password"
              />
            </v-form>
          </div>
        </v-widget>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LoadingState from '@/components/LoadingState'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'MyAccount',

  components: {
    LoadingState
  },

  data () {
    return {
      user: this.$http.make('auth:user')
    }
  },

  actionBar () {
    return {
      title: 'Account',
      actions: [
        {
          text: 'Save',
          event: 'save',
          disabled: true
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/me'
    }),

    saveActionStates () {
      return {
        disabled: !this.user || this.user.inProgress || !this.user.isDirty() || this.user.errors.length,
        loading: !this.user || this.user.inProgress
      }
    }
  },

  mounted () {
    this.user = this.$http.make('auth:user', this.currentUser.payload())
  },

  methods: {
    ...mapMutations({
      'setUser': 'auth/ME'
    }),

    goBack () {
      this.$router.history.back()
    },

    async onActionSave () {
      await this.user.save()
      this.setUser(this.$http.make('auth:user', this.user.without(['password', 'password_confirmation']).payload()))
      this.user.setup()

      this.$toast(this.$t('Account saved'))
    }
  }
}
</script>
